import React, {
  useContext,
  createContext,
  useState,
  useCallback,
  useMemo,
} from 'react'

const AppContext = createContext({
  isMini: false,
  toggleSidebarState: () => {},
})

export const AppContextProvider = ({ children }: React.PropsWithChildren) => {
  const [isMini, setIsMini] = useState(false)

  const toggleSidebarState = useCallback(() => {
    setIsMini(!isMini)
  }, [isMini])

  const value = useMemo(
    () => ({ isMini, toggleSidebarState }),
    [isMini, toggleSidebarState]
  )

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export const useSidebar = () => {
  return useContext(AppContext)
}
